/* tslint:disable */
/* eslint-disable */
/**
 * Catalog Manager
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: mix-dev@amazon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ResourceList } from '../models';
// @ts-ignore
import { ResourceListOutput } from '../models';
// @ts-ignore
import { SimpleError } from '../models';
/**
 * StageApi - axios parameter creator
 * @export
 */
export const StageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Enumerate resources in the specified catalog stage
         * @param {string} stage The stage in the catalog where the operation should take place
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources: async (stage: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('listResources', 'stage', stage)
            const localVarPath = `/stages/{stage}/resources`
                .replace(`{${"stage"}}`, encodeURIComponent(String(stage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Promote resources into the specified catalog stage
         * @param {string} stage The stage in the catalog where the operation should take place
         * @param {string} source The stage where resources are promoted from
         * @param {ResourceList} [resourceList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteResources: async (stage: string, source: string, resourceList?: ResourceList, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('promoteResources', 'stage', stage)
            // verify required parameter 'source' is not null or undefined
            assertParamExists('promoteResources', 'source', source)
            const localVarPath = `/stages/{stage}/resources/promote`
                .replace(`{${"stage"}}`, encodeURIComponent(String(stage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resourceList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revert resources from the specified catalog stage
         * @param {string} stage The stage in the catalog where the operation should take place
         * @param {ResourceList} [resourceList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revertResources: async (stage: string, resourceList?: ResourceList, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('revertResources', 'stage', stage)
            const localVarPath = `/stages/{stage}/resources/revert`
                .replace(`{${"stage"}}`, encodeURIComponent(String(stage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resourceList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StageApi - functional programming interface
 * @export
 */
export const StageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Enumerate resources in the specified catalog stage
         * @param {string} stage The stage in the catalog where the operation should take place
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listResources(stage: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourceListOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listResources(stage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Promote resources into the specified catalog stage
         * @param {string} stage The stage in the catalog where the operation should take place
         * @param {string} source The stage where resources are promoted from
         * @param {ResourceList} [resourceList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promoteResources(stage: string, source: string, resourceList?: ResourceList, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promoteResources(stage, source, resourceList, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Revert resources from the specified catalog stage
         * @param {string} stage The stage in the catalog where the operation should take place
         * @param {ResourceList} [resourceList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revertResources(stage: string, resourceList?: ResourceList, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revertResources(stage, resourceList, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StageApi - factory interface
 * @export
 */
export const StageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StageApiFp(configuration)
    return {
        /**
         * 
         * @summary Enumerate resources in the specified catalog stage
         * @param {string} stage The stage in the catalog where the operation should take place
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources(stage: string, options?: any): AxiosPromise<ResourceListOutput> {
            return localVarFp.listResources(stage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Promote resources into the specified catalog stage
         * @param {string} stage The stage in the catalog where the operation should take place
         * @param {string} source The stage where resources are promoted from
         * @param {ResourceList} [resourceList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteResources(stage: string, source: string, resourceList?: ResourceList, options?: any): AxiosPromise<void> {
            return localVarFp.promoteResources(stage, source, resourceList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revert resources from the specified catalog stage
         * @param {string} stage The stage in the catalog where the operation should take place
         * @param {ResourceList} [resourceList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revertResources(stage: string, resourceList?: ResourceList, options?: any): AxiosPromise<void> {
            return localVarFp.revertResources(stage, resourceList, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StageApi - object-oriented interface
 * @export
 * @class StageApi
 * @extends {BaseAPI}
 */
export class StageApi extends BaseAPI {
    /**
     * 
     * @summary Enumerate resources in the specified catalog stage
     * @param {string} stage The stage in the catalog where the operation should take place
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageApi
     */
    public listResources(stage: string, options?: AxiosRequestConfig) {
        return StageApiFp(this.configuration).listResources(stage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Promote resources into the specified catalog stage
     * @param {string} stage The stage in the catalog where the operation should take place
     * @param {string} source The stage where resources are promoted from
     * @param {ResourceList} [resourceList] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageApi
     */
    public promoteResources(stage: string, source: string, resourceList?: ResourceList, options?: AxiosRequestConfig) {
        return StageApiFp(this.configuration).promoteResources(stage, source, resourceList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revert resources from the specified catalog stage
     * @param {string} stage The stage in the catalog where the operation should take place
     * @param {ResourceList} [resourceList] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageApi
     */
    public revertResources(stage: string, resourceList?: ResourceList, options?: AxiosRequestConfig) {
        return StageApiFp(this.configuration).revertResources(stage, resourceList, options).then((request) => request(this.axios, this.basePath));
    }
}
